export const socialsData = {
  github: "https://github.com/bhaskarkrp",
  linkedIn: "https://www.linkedin.com/in/bhaskarkumarpanjiyar/",
  linkedInReccomend: "https://www.linkedin.com/in/bhaskarkumarpanjiyar/details/recommendations/?detailScreenTabIndex=0",
  twitter: "https://twitter.com/BhaskarPanjiyar",
  instagram: "https://www.instagram.com/runtime._error._",
  leetcode: "https://leetcode.com/bhaskarkumar0022/",
  codepen: "https://codepen.io/",
  reddit: "https://www.reddit.com/user/",
  blogger: "https://www.blogger.com/",
  medium: "https://medium.com/",
  stackOverflow: "https://stackoverflow.com/users/",
  gitlab: "https://gitlab.com/",
  youtube: "https://youtube.com/",
  resume:
    "https://drive.google.com/file/d/1W5XO6m-uPA11c-PuPYVJTAKOzh1n-3bK/view?usp=sharing",
};
